module.exports = __webpack_public_path__ + "static/media/house.a8d59576.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/common/icon/house.png
// module id = 677
// module chunks = 0